const { MinimogThemeStyles, MinimogThemeScripts } = window;
class QuickView {
  constructor() {
    this.modal = new MinimogTheme.Modal();
		this.isOpen = false
this.scrollY = 0;
     const originalClose = this.modal.close.bind(this.modal);

this.modal.close = (...args) => {
  originalClose(...args);

  // 🔥 Emit custom event
  window.MinimogEvents.emit("quickview:closed");
};


window.MinimogEvents.subscribe("quickview:closed", () => {
  if (this.isOpen && window.innerWidth < 768) {
    this.unlockScroll();
  }
  this.isOpen = false;
});

    addEventDelegate({
      selector: ".m-product-quickview-button",
      handler: (e, target) => {
        e.preventDefault();
        this.target = target;
        this.toggleLoading(this.target, true);
        const productHandle = target.dataset.productHandle;
        if (productHandle) this.fetchHtml(productHandle);
      },
    });
  
    window.MinimogEvents.subscribe(MinimogTheme.pubSubEvents.cartUpdate, () => {
      if (this.modal && this.isOpen) MinimogTheme.ProductQuickView.close()
    });

    // Global variant:change listener — registered once at page load,
    // dynamically finds the quantity input inside the currently open modal
    document.addEventListener('variant:change', (e) => {
      if (!this.modalContent) return;
      var wrapper = this.modalContent.querySelector('m-quantity-input');
      if (!wrapper) return;
      var input = wrapper.querySelector('input[name="quantity"]');
      if (!input) return;

      var variant = e.detail.variant;
      if (!variant) return;

      this._updateQtyFromVariant(input, variant);
    });
  }
lockScroll() {
 this.scrollY = window.scrollY;

  document.body.style.position = "fixed";
  document.body.style.top = `-${this.scrollY}px`;
  document.body.style.left = "0";
  document.body.style.right = "0";
  document.body.style.width = "100%";
}

unlockScroll() {
 const top = document.body.style.top;

  document.body.style.position = "";
  document.body.style.top = "";
  document.body.style.left = "";
  document.body.style.right = "";
  document.body.style.width = "";

   window.scrollTo({
    top: Math.abs(parseInt(top || "0")),
    behavior: "instant" // critical
  });
}
  fetchHtml(productHandle) {
    console.log(this.modal)
    loadAssetsNew([MinimogThemeStyles.product, MinimogThemeStyles.productInventory], "quick-view-assets");
    fetchSection("product-quickview", { url: `${window.MinimogSettings.base_url}products/${productHandle}` })
      .then((html) => {
        this.modalContent = html.querySelector(".m-product-quickview");
        const firstModel = html.querySelector("product-model");
        this.mediaGallery = this.modalContent.querySelector("media-gallery");
        loadAssetsNew([MinimogThemeScripts.productMedia, MinimogThemeScripts.variantsPicker, MinimogThemeScripts.productInventory], "variants-picker", () => {
          const colorScheme = this.modalContent.dataset.colorScheme;
          this.setupQuantityInput();
          this.modal.appendChild(this.modalContent);
         // 🔥 Mobile full screen
if (window.innerWidth < 768) {
  this.modal.setWidth("100%");
  this.lockScroll()
} else {
  this.modal.setWidth("960px");
}

 // 🔥 lock background scroll
this.modal.open();

          this.modal.setSizes(`m-gradient ${colorScheme}`);
 					this.toggleLoading(this.target, false)
 					this.isOpen = true
        });
        if (firstModel) {
          loadAssetsNew(
            [
              MinimogThemeScripts.productModel,
              "https://cdn.shopify.com/shopifycloud/model-viewer-ui/assets/v1.0/model-viewer-ui.css",
            ],
            "product-model-assets"
          );
        }
      })
      .catch(console.error);
  }

  setupQuantityInput() {
    var wrapper = this.modalContent.querySelector('m-quantity-input');
    if (!wrapper) return;
    var input = wrapper.querySelector('input[name="quantity"]');
    if (!input) return;

    // On user typing: cap value to max/min
    input.addEventListener('input', function() {
      var max = parseInt(input.max);
      var min = parseInt(input.min) || 1;
      var value = parseInt(input.value);
      if (isNaN(value)) return;
      if (value > max) input.value = max;
      if (value < min) input.value = min;
    });

    // Immediately sync input max/min with the variant picker's current variant
    // (needed because variant-picker fires variant:change during HTML parsing,
    //  before this.modalContent was set, so the global listener missed it)
    var variantPicker = this.modalContent.querySelector('variant-picker');
    if (variantPicker && variantPicker.currentVariant) {
      this._updateQtyFromVariant(input, variantPicker.currentVariant);
    }
  }

  // Shared helper: update quantity input max/min from a variant object
  _updateQtyFromVariant(input, variant) {
    var max = variant.inventory_quantity;
    var invPolicy = variant.inventory_policy;

    // Fallback: read from [data-variant-inventory] JSON if variant object lacks the fields
    if (max == null) {
      var invScript = this.modalContent.querySelector('script[data-variant-inventory]');
      if (invScript) {
        try {
          var invData = JSON.parse(invScript.textContent);
          if (invData[variant.id]) {
            max = invData[variant.id].inventory_quantity;
            invPolicy = invData[variant.id].inventory_policy;
          }
        } catch(e) {}
      }
    }

    if (max == null) max = 0;
    if (invPolicy === 'continue' && max <= 0) {
      max = 999999;
    }

    var min = (variant.quantity_rule && variant.quantity_rule.min != null) ? variant.quantity_rule.min : 1;
    var step = (variant.quantity_rule && variant.quantity_rule.increment != null) ? variant.quantity_rule.increment : 1;

    input.max = max;
    input.min = min;
    input.step = step;
    input.setAttribute('data-max', max);
    input.setAttribute('data-min', min);

    var currentVal = parseInt(input.value);
    if (isNaN(currentVal) || currentVal < min) {
      input.value = min;
    } else if (currentVal > max) {
      input.value = max;
    }

    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  close(e) {
    this.modal.close(e)

    this.isOpen = false
  }

  toggleLoading(target, loading) {
    if (loading) {
      target.classList.add("m-spinner-loading");
    } else {
      target.classList.remove("m-spinner-loading");
    }
  }
}

MinimogTheme.ProductQuickView = new QuickView();

